import { SearchTerm } from "./SearchTerm";

const KsKeySearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "name",
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "ksKeyTypeName",
        searchOnName: "ksKeyType.trnName",
        translationKey: "type"
    }
];

export default KsKeySearch;
